/* src/main.js */
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import './assets/main.css'

const token = localStorage.getItem('user-token')

if (token) {

    axios.defaults.headers.common['Authorization'] = `Token ${token}`
}

axios.interceptors.request.use(
  config => {

    const token = localStorage.getItem('user-token')

    if (token) {
    
      config.headers['Authorization'] = `Token ${token}`
    }
    return config
  },
  error => {

    return Promise.reject(error)
  }
)

if ('serviceWorker' in navigator) {

  navigator.serviceWorker.register('/sw.js')
    .then(() => console.log('SW registrato correttamente'))
    .catch(err => console.error('Errore SW:', err))
}

window.addEventListener('beforeinstallprompt', (e) => {

  e.preventDefault()
  window.deferredPrompt = e;
  console.log("Evento di installazione catturato!")
})

const app = createApp(App)
const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)

const mountApp = () => {
  const vm = app.mount('#app')
  console.log("App montata con successo");
}

const vm = app.mount('#app')

if (window.__VUE_DEVTOOLS_GLOBAL_HOOK__) {

  window.__VUE_DEVTOOLS_GLOBAL_HOOK__.emit('app:init', app, vm, {})
}

/*
if ('serviceWorker' in navigator) {

  navigator.serviceWorker.register('/sw.js')
    .then(reg => {

      reg.onupdatefound = () => {

        const installingWorker = reg.installing

        installingWorker.onstatechange = () => {

          if (installingWorker.state === 'installed') {

            if (navigator.serviceWorker.controller) {

              console.log('Nuovo contenuto disponibile, ricarica la pagina.')
            }
          }
        }
      }
    })
}
*/